import { Navigate, useLocation } from 'react-router';
import { encodeBaseParamValue } from '../Utils/routerUtils';

export const V0RouteHandler: React.FC<React.PropsWithChildren<{}>> = () => {
  const location = useLocation();
  const [_, v0System, v0Database, ...rest] = location.pathname.split('/');
  const searchParams = new URLSearchParams(location.search);
  const usernameParam = searchParams.get('username');
  const system = v0System === 'GBS' ? 'GAS' : v0System;
  const newPath = `/1/${system}/${
    usernameParam ? encodeBaseParamValue(usernameParam, 'base64url') : '_'
  }/${v0Database}/${rest.join('/')}`;
  return (
    <Navigate to={{ pathname: newPath, search: location.search }} replace />
  );
};
